(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CampaignManagementController', campaignManagementController)

    campaignManagementController.inject = ['$scope', 'ngTableParams', '$http', 'LangService', 'CampaignManagementService', 'NotificationService', '$state']

  function campaignManagementController ( $scope, ngTableParams, $http, LangService, CampaignManagementService, NotificationService, $state) {

    LangService
    .getPageLabels({ 'page': 'menu.campaign' })
    .$promise
    .then(function (data) {
      vm.labelsPage = data.lang;
    });

    var vm = this;
    vm.campaign = {
      "name": null,
      "dueDate": null,
      "active": null,
      "channelType": null,
      "message": null,
      "template": null,
      "messageParameters": [],
      "channelConfig": {
        "sendingChannelId": null,
        "sectorId": null,
        "replyChannelEmailId": null,
        "subjectOfEmail": null,
        "fieldWithEmail": null,
        "useChatbotForAttendance": null,
        "ret": null,
        "invoices": null
      }
    }

    vm.filter = {
      "campaignName": null,
      "start": null,
      "end": null,
      "active": null,
      "startFormat": null,
      "endFormat": null
    }

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

   vm.parseStatus = function(status){
    if (status) {
      return 'Ativo';
    }
      return 'Inativo'
   }

    index();

    vm.index = () => {
      index();
    }

    vm.edit = function(id) {
      $state.go('main.campaign-management-edit', { id: id });
    }

    vm.downloadFile = function(id) {
      CampaignManagementService.downloadFile({'id': id}).$promise
        .then(function(response) {
          const csvContent = atob(response.data.fileAsBase64);
          var file = new Blob([csvContent], {type: "data:text/csv;charset=utf-8"});

          var url = window.URL || window.webkitURL;

          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href',url.createObjectURL(file));
          downloadLink.attr('target','_self');
          downloadLink.attr('download', response.data.name);
          downloadLink[0].click();
      })
    }


    function index() {
      vm.indexList = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {

          var end;
          var start;

          if (vm.filter.start) {
            start = moment(vm.filter.start,"DD/MM/YYYY").format("YYYY-MM-DD"); 
          }
          if (vm.filter.end) {
            end = moment(vm.filter.end,"DD/MM/YYYY").format("YYYY-MM-DD"); 
          }

          CampaignManagementService
            .index({
              campaignName: vm.filter.campaignName,
              channelType: vm.filter.channelType,
              start: start,
              end: end,
              active: vm.filter.active,
              page: params.page()
            })
            .$promise
            .then(function (response) {
              $defer.resolve(response.data)
              params.total(response.total);
              vm.Total = (response.total);
            }).catch(function (data) {
              NotificationService.errorHandler(data, data.data.error);
            });
        }
      })
    }
  }
})();
